/* eslint-disable react/prop-types */
import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Line from "../images/line.svg"
import NavLeft from "../images/pfeil-links.svg"
import NavRight from "../images/pfeil-rechts.svg"
import ImageGallery from "react-image-gallery"
import BeiAllenReisenInkludiertHomepage from "../components/bei-allen-reisen-inkludiert-homepage"
import MagalogPDF from "../images/katalog2020.pdf"
import Freizeitleben from "../images/freizeitleben.png"
import Magalog from "../images/magalog.png"
import Bewertungsformular from "../components/bewertungsformular"

const IndexPage = ({ data }) => {
  var galleryItems = []
  data.contentfulHome.slideshow.map((reise) => {
    var bar = reise
    var foo
    var klasse1
    var klasse2
    if (reise.typ === "Wanderreise") {
      foo = "wanderreisen"
      klasse1 = "button-homepage-wanderreise"
      klasse2 = "button-homepage-alle-wanderreisen"
    } else if (reise.typ === "Segel-Kreuzfahrt") {
      foo = "segelkreuzfahrten"
      klasse1 = "button-homepage-segelkreuzfahrt"
      klasse2 = "button-homepage-alle-segelkreuzfahrten"
    } else if (reise.typ === "Golfreise") {
      foo = "golfreisen"
      klasse1 = "button-homepage-golfreise"
      klasse2 = "button-homepage-alle-golfreisen"
    }

    galleryItems.push({
      renderItem: () => (
        <div className="reise-hero slideshow slideshow-img">
          <Link
            className="reise"
            to={foo + "/" + reise.land.toLowerCase() + "/" + reise.slug}
          >
            <GatsbyImage
              image={{
                ...bar.heroImage.gatsbyImageData,
              }}
              className="slideshow-img"
            />
            <div className={`slideshow-text reise-text-${foo}`}>
              <h3>{reise.destination}</h3>
              <p>{reise.kurzbeschreibung}</p>
              <div className="buchen-button-big-list-homepage">
                <div className="slideshow-text-buttons">
                  <Link
                    to={foo + "/" + reise.land.toLowerCase() + "/" + reise.slug}
                    className={
                      "buchen-button-big-link buchen-button-big-link-wanderreise-liste " +
                      klasse1
                    }
                  >
                    Zum Angebot
                  </Link>
                  <div className="buchen-button-big-list-homepage with-margin-left">
                    <Link
                      to={foo}
                      className={
                        "buchen-button-big-link buchen-button-big-link-wanderreise-liste " +
                        klasse2
                      }
                    >
                      Alle {foo}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      ),
    })
    return null
  })

  function renderRightNav(onClick, disabled) {
    return (
      <button
        className="image-gallery-custom-right-nav"
        disabled={disabled}
        onClick={onClick}
        style={{
          backgroundImage: `url(${NavRight})`,
        }}
      >
        <span hidden>Nach rechts</span>
      </button>
    )
  }

  function renderLeftNav(onClick, disabled) {
    return (
      <button
        className="image-gallery-custom-left-nav"
        disabled={disabled}
        onClick={onClick}
        style={{
          backgroundImage: `url(${NavLeft})`,
        }}
      >
        <span hidden>Nach links</span>
      </button>
    )
  }

  return (
    <Layout>
      <Seo title="Home" />
      {data.contentfulHome.slideshowAnzeigen && (
        <section className="max-w-[920px] mx-auto">
          <ImageGallery
            items={galleryItems}
            showThumbnails={false}
            showFullscreenButton={false}
            showPlayButton={false}
            showBullets={true}
            autoPlay={false}
            slideInterval="6000"
            renderRightNav={renderRightNav}
            renderLeftNav={renderLeftNav}
          />
        </section>
      )}

      <section className="featured-reisen-section">
        <div
          className="homepage-featured-reisen"
          style={{ padding: 0, marginTop: "5vw" }}
        >
          {data.contentfulHome.featuredReisen.map((reise, index) => {
            var bar = reise
            var foo
            var klasse1
            if (reise.typ === "Wanderreise") {
              foo = "wanderreisen"
              klasse1 = "button-homepage-wanderreise"
            } else if (reise.typ === "Segel-Kreuzfahrt") {
              foo = "segelkreuzfahrten"
              klasse1 = "button-homepage-segelkreuzfahrt"
            } else if (reise.typ === "Golfreise") {
              foo = "golfreisen"
              klasse1 = "button-homepage-golfreise"
            }

            return (
              <div key={index} className="homepage-featured-reisen-image">
                <Link to={foo + "/" + bar.land.toLowerCase() + "/" + bar.slug}>
                  <GatsbyImage
                    image={{
                      ...reise.heroImage.gatsbyImageData,
                    }}
                  />
                  <div className={`featured-reisen-text reise-text-${foo}`}>
                    <div className="buchen-button-big-list-homepage">
                      <Link
                        to={foo + "/" + bar.land.toLowerCase() + "/" + bar.slug}
                        className={
                          "buchen-button-big-link buchen-button-big-link-wanderreise-liste " +
                          klasse1
                        }
                      >
                        {reise.destination}
                      </Link>
                    </div>
                  </div>
                </Link>
              </div>
            )
          })}
        </div>
      </section>

      <section>
        <div className="reisen-liste-headline reisen-liste-headline-homepage">
          <h1>Blog</h1>
          <img className="line" src={Line} alt="Trennlinie"></img>
        </div>
        <section
          className="reise-beschreibung-background"
          style={{ marginTop: "3rem" }}
        >
          <div className="reise-beschreibung-container">
            <div className="reise-beschreibung reise-beschreibung-blog">
              <div className="float-left">
                <div className="uber-hero blog-hero blog-hero-homepage">
                  <GatsbyImage
                    image={
                      data.contentfulHome.featuredBlogPost.heroImage
                        .gatsbyImageData
                    }
                  />
                  <div className="uber-headline blog-headline-homepage">
                    <h1>{data.contentfulHome.featuredBlogPost.title}</h1>
                  </div>
                </div>
              </div>

              <div
                className="reise-beschreibung-text"
                style={{ paddingTop: "1.45rem" }}
              >
                {
                  data.contentfulHome.featuredBlogPost.body.childMarkdownRemark
                    .excerpt
                }{" "}
                <br />
                <div
                  style={{
                    textAlign: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  className="buchen-button-big-list blog-buttons-homepage"
                >
                  <Link
                    to={"blog/" + data.contentfulHome.featuredBlogPost.slug}
                    className="buchen-button-big-link homepage-blog-link-weiterlesen"
                  >
                    Weiterlesen
                  </Link>{" "}
                  <br />
                  <Link to="blog/" className="buchen-button-big-link">
                    Zum Blog
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <section className="mt-32 max-w-[920px] mx-auto">
        <h2 className="reise-headline testimonials-headline">★★★★★</h2>
        <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2 }}>
          <Masonry>
            {data.contentfulUberUns.testimonials.map((entry) => (
              <div
                className="relative flex flex-col gap-2 m-4 p-8 border shadow bg-slate-50"
                key={entry.id}
              >
                {entry.bild && (
                  <GatsbyImage
                    className=""
                    alt={entry.name}
                    image={entry.bild.gatsbyImageData}
                  />
                )}
                <div
                  className=""
                  dangerouslySetInnerHTML={{
                    __html: entry.text.childMarkdownRemark.html,
                  }}
                ></div>
                <span className="font-serif absolute top-0 left-0 text-8xl m-0 p-0 text-slate-500 opacity-10">
                  “
                </span>
                <span className="font-serif absolute bottom-0 right-0 text-8xl m-0 p-0 text-slate-500 opacity-10">
                  ”
                </span>

                <div className="flex flex-row items-center gap-2">
                  {entry.profilbildAutor && (
                    <GatsbyImage
                      className="rounded-full"
                      alt={entry.autor}
                      image={entry.profilbildAutor.gatsbyImageData}
                    />
                  )}

                  <div className="testimonial-author">{entry.name}</div>
                </div>
              </div>
            ))}
          </Masonry>
        </ResponsiveMasonry>
        <div className="flex flex-wrap justify-center gap-8 m-4">
          <Bewertungsformular />
          <Link
            to="bewertungen/"
            className="tracking-[1.7px] py-5 px-12 border-2 uppercase font-bold border-black text-black bg-slate-300/10 text-[9px] text-center w-full md:w-64"
          >
            Alle Bewertungen ansehen
          </Link>
        </div>
      </section>
      <section>
        <div className="philosophie philosophie-homepage">
          <div>
            <h1
              className="philosophie-headline"
              style={{
                fontFamily: "Eczar",
                textTransform: "none",
                fontWeight: "bold",
              }}
            >
              Mehr Lesestoff
            </h1>
            <div className="philosophie-text" style={{ fontFamily: "Roboto" }}>
              Entdecken Sie das Bordmagazin FREIZeitleben und unseren aktuellen
              Bärkopf Katalog.
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                <a
                  href="https://freizeitleben.at"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="h-[300px]"
                    height="300"
                    src={Freizeitleben}
                    alt="FREIZeitleben"
                    style={{ margin: 0 }}
                  />
                  <p>FREIZeitleben</p>
                </a>
                <a href={MagalogPDF} target="_blank" rel="noreferrer">
                  <img
                    className="h-[300px]"
                    height="300"
                    src={Magalog}
                    alt="Magalog"
                    style={{ margin: 0 }}
                  />
                  <p>Katalog</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="uber-hero uber-hero-homepage">
          <GatsbyImage
            image={data.contentfulUberUns.image.gatsbyImageData}
            className="uber-image-homepage"
          />
          <div className="uber-headline uber-headline-homepage">
            <h1>{data.contentfulUberUns.title}</h1>
            <img className="line" src={Line} alt="Trennlinie"></img>
          </div>
          <div className="uber-slogan uber-slogan-homepage">
            <div
              style={{ fontFamily: "BullettoKilla" }}
              dangerouslySetInnerHTML={{
                __html: data.contentfulUberUns.slogan.childMarkdownRemark.html,
              }}
            ></div>
            <Link
              to="ueber-uns/"
              className="buchen-button-big-link"
              style={{
                borderColor: "white",
                color: "white",
                backgroundColor: "rgba(0,0,0,0.5)",
              }}
            >
              Mehr über uns
            </Link>
          </div>
        </div>
      </section>
      <section style={{ marginTop: "10vh" }}>
        <BeiAllenReisenInkludiertHomepage />
      </section>
    </Layout>
  )
}

export const query = graphql`
  {
    contentfulBeiAllenReisenInkludiert(
      id: { eq: "d4ef62cf-48a7-57ac-a468-2ea802037e26" }
    ) {
      title
      bulletPoints {
        title
        icon {
          file {
            url
          }
        }
        text {
          id
          childMarkdownRemark {
            html
          }
        }
      }
    }
    contentfulUberUns {
      testimonials {
        id
        name
        text {
          childMarkdownRemark {
            html
          }
        }
      }
      title
      image {
        gatsbyImageData(layout: FULL_WIDTH)
      }
      slogan {
        childMarkdownRemark {
          html
        }
      }
    }
    contentfulHome {
      slideshowAnzeigen
      slideshow {
        slug
        land
        typ
        destination
        kurzbeschreibung
        heroImage {
          gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 1)
        }
      }
      featuredReisen {
        slug
        land
        typ
        destination
        kurzbeschreibung
        heroImage {
          gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 1)
        }
      }
      featuredBlogPost {
        title
        slug
        body {
          childMarkdownRemark {
            excerpt(pruneLength: 600)
          }
        }
        heroImage {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      linkZuFacebookProfil
      linkZuInstagramProfil
      slogan {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

export default IndexPage
